import ResizeObserver from 'resize-observer-polyfill';
import {gsap, Quart} from 'gsap/all';
import utils from '@/_modules/utils';
import eventMv from '@/_modules/eventMv';
import eventSort from '@/_modules/eventSort';
import gnav from '@/_modules/common/gnav';
import footer from '@/_modules/common/footer';
import snsShare from '@/_modules/common/snsShare';
import bgShadow from '@/_modules/common/bgShadow';

export default class pageEvent {
  constructor() {
    this.getHeight100();
    this.winH = 0;
    this.conH = 0;

    gnav.once();
    footer.once();
    snsShare.once();
    bgShadow.once();
    eventMv.once();
    eventSort.once();

    this.init();
  }

  init() {
    this.resizeObserver = new ResizeObserver(this.resize.bind(this));
    this.resizeObserver.observe(document.getElementById('c-container'));
  }

  start() {
    gnav.start();
    eventMv.start();
  }

  getHeight100() {
    //const vh = window.innerHeight * 0.01;
    //document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  resize(entries) {
    gnav.resize();
    footer.resize();
    bgShadow.resize();
    eventMv.resize();
  }

  scroll(e) {
    let scrollY = scrollY = utils.getScrollTop();
  }
}
